/** @format */

import yandexIllustrationSvg from './yandex-illustration.svg';

const YandexAccountsIllustration = () => (
  <img
    data-testid='yandex-accounts-illustration'
    src={yandexIllustrationSvg}
    alt='Yandex accounts illustration'
  />
);

export default YandexAccountsIllustration;
